export const MARKDOWN_PARSER_COMPONENTS_CUSTOMIZATION = {
  table: ({ node, children, ...props }) => (
    <div className="w-full overflow-x-scroll scrollbar-hide">
      <table className="w-full" {...props}>
        {children}
      </table>
    </div>
  ),
  thead: ({ node, children, ...props }) => (
    <thead className="text-neutral-white" {...props}>
      {children}
    </thead>
  ),
  tr: ({ node, children, ...props }) => (
    <tr className="odd:bg-neutral-40" {...props}>
      {children}
    </tr>
  ),
  td: ({ node, children, ...props }) => (
    <td className="px-8 py-2 text-nowrap" {...props}>
      {children}
    </td>
  ),
  th: ({ node, children, ...props }) => (
    <th className="p-2 font-bold bg-primary-50 text-neutral-white" {...props}>
      {children}
    </th>
  ),
  p: ({ node, children, ...props }) => (
    <p style={{ wordBreak: "break-word", textAlign: "justify" }} {...props}>
      {children}
    </p>
  ),
  a: ({ node, children, ...props }) => (
    <a style={{ wordBreak: "break-word" }} {...props}>
      {children}
    </a>
  ),
  h1: ({ node, children, ...props }) => (
    <h1 className="my-8 text-primary-50" {...props}>
      {children}
    </h1>
  ),
  h2: ({ node, children, ...props }) => (
    <h2 className="my-6 text-primary-50" {...props}>
      {children}
    </h2>
  ),
  h3: ({ node, children, ...props }) => (
    <h3 className="my-4 text-primary-50" {...props}>
      {children}
    </h3>
  ),
  h4: ({ node, children, ...props }) => (
    <h4 className="text-primary-50" {...props}>
      {children}
    </h4>
  ),
};